<template>
  <el-dialog 
    title="创建资源类型" 
    :visible.sync="dialogVisible" 
    width="500px" 
    @close="resetForm" 
    :close-on-click-modal="false"
  >
    <div class="form-container">
      <el-form :model="createForm" :rules="rules" ref="createForm" label-width="120px" size="small">
        <el-form-item label="资源类型名称：" prop="name">
          <el-input v-model="createForm.name" placeholder="请输入资源类型名称"></el-input>
        </el-form-item>
        <el-form-item label="状态：" prop="status">
          <el-select v-model="createForm.status" placeholder="请选择状态" style="width: 100%;">
            <el-option label="有效" :value="0"></el-option>
            <el-option label="无效" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="父ID：" prop="p_id" style="display: none;">
          <el-input type="number" v-model="createForm.p_id" placeholder="请输入父ID（可选）"></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-input type="textarea" :rows="3" v-model="createForm.remark" placeholder="请输入备注（可选）"></el-input>
        </el-form-item>
      </el-form>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="dialogVisible = false">取消</el-button>
      <el-button size="small" type="primary" @click="submitForm('createForm')">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'CreateComputeType',
  data() {
    return {
      dialogVisible: false,
      createForm: {
        name: '',
        status: 0,
        p_id: 0,
        remark: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入资源类型名称', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      }
    };
  },
  methods: {
    openDialog() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.createForm) {
          this.$refs.createForm.clearValidate();
        }
      });
    },

    resetForm() {
      if (this.$refs.createForm) {
        this.$refs.createForm.resetFields();
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) return;

        const postData = { ...this.createForm };

        this.$axios.post('/api-30216/api/compute-types', postData, {
          headers: { 'Content-Type': 'application/json' },
          transformRequest: [postData => JSON.stringify(postData)]
        })
          .then(res => {
            if (res.code === 200) {
              this.$message.success(res.message || '创建成功');
              this.dialogVisible = false;
              this.$emit('success');
            } else {
              this.$message.error(res.message || '创建失败');
            }
          })
          .catch(err => {
            let errorMessage = '请求失败';
            if (err && err.response && err.response.data && err.response.data.message) {
              errorMessage = err.response.data.message;
            } else if (err && err.message) {
              errorMessage = err.message;
            }
            this.$message.error(errorMessage);
            console.error('提交错误详情:', err);
          });
      });
    }
  }
};
</script>

<style scoped>
.form-container {
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 10px;
}
.form-container::-webkit-scrollbar {
  width: 6px;
}
.form-container::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 3px;
}
.el-dialog .el-form-item {
  margin-bottom: 18px;
}
.dialog-footer {
  text-align: right;
}
</style>